import { render, staticRenderFns } from "./score_1.vue?vue&type=template&id=5d672ffe&scoped=true&"
import script from "./score_1.vue?vue&type=script&lang=js&"
export * from "./score_1.vue?vue&type=script&lang=js&"
import style0 from "./score_1.vue?vue&type=style&index=0&id=5d672ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d672ffe",
  null
  
)

export default component.exports